import React from 'react';

// Rótulos da lista nova (.dc.html:241-243). A seta indica a ordenação padrão (última execução,
// mais recente primeiro); a ordenação em si chega com os dados.
const COLUMN_LABELS = ['DESCRIÇÃO', 'HORIZONTE', 'STATUS · ÚLTIMA EXECUÇÃO ↓', 'AÇÕES'] as const;

/**
 * Cabeçalho da lista da aba Meus Estudos: 4 rótulos e a coluna vazia do chevron, na mesma grade
 * das linhas (`_grid.scss`).
 */
export default function TableHeader() {
  return (
    <div className="my-studies-grid my-studies-table-header">
      {COLUMN_LABELS.map((label) => <span key={label}>{label}</span>)}
      <span aria-hidden="true" />
    </div>
  );
}
